var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("fieldset", { staticClass: "mb-3", attrs: { disabled: _vm.loading } }, [
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.invoice_requested,
              expression: "formData.invoice_requested",
            },
          ],
          staticClass: "form-check-input",
          attrs: {
            type: "checkbox",
            name: "invoice_requested",
            id: "invoice_requested",
          },
          domProps: {
            checked: Array.isArray(_vm.formData.invoice_requested)
              ? _vm._i(_vm.formData.invoice_requested, null) > -1
              : _vm.formData.invoice_requested,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.formData.invoice_requested,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(
                      _vm.formData,
                      "invoice_requested",
                      $$a.concat([$$v])
                    )
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.formData,
                      "invoice_requested",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.formData, "invoice_requested", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: "invoice_requested" },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$t("booking.inputs.hasEuTaxNumAndWantInvoice.label")
                ) +
                "\n            "
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.formData.invoice_requested
      ? _c("fieldset", { attrs: { disabled: _vm.loading } }, [
          _c("div", { staticClass: "mb-3" }, [
            _c("label", { attrs: { for: "invoice_eu_tax_number" } }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("booking.inputs.invoice.eu_tax_number.label")) +
                  ":\n            "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.invoice_eu_tax_number,
                  expression: "formData.invoice_eu_tax_number",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "invoice_eu_tax_number",
                id: "invoice_eu_tax_number",
                maxlength: "50",
                placeholder: _vm.$t(
                  "booking.inputs.invoice.eu_tax_number.placeholder"
                ),
                required: "",
              },
              domProps: { value: _vm.formData.invoice_eu_tax_number },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.formData,
                    "invoice_eu_tax_number",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3" }, [
            _c("label", { attrs: { for: "invoice_name" } }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("booking.inputs.invoice.name.label")) +
                  ":\n            "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.invoice_name,
                  expression: "formData.invoice_name",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "invoice_address",
                id: "invoice_name",
                maxlength: "255",
                placeholder: _vm.$t("booking.inputs.invoice.name.placeholder"),
                required: "",
              },
              domProps: { value: _vm.formData.invoice_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "invoice_name", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3" }, [
            _c("label", { attrs: { for: "invoice_address" } }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("booking.inputs.invoice.address.label")) +
                  ":\n            "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.invoice_address,
                  expression: "formData.invoice_address",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "invoice_address",
                id: "invoice_address",
                maxlength: "255",
                placeholder: _vm.$t(
                  "booking.inputs.invoice.address.placeholder"
                ),
                required: "",
              },
              domProps: { value: _vm.formData.invoice_address },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "invoice_address", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3" }, [
            _c("label", { attrs: { for: "invoice_town" } }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("booking.inputs.invoice.town.label")) +
                  ":\n            "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.invoice_town,
                  expression: "formData.invoice_town",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "invoice_town",
                id: "invoice_town",
                maxlength: "50",
                placeholder: _vm.$t("booking.inputs.invoice.town.placeholder"),
                required: "",
              },
              domProps: { value: _vm.formData.invoice_town },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "invoice_town", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3" }, [
            _c("label", { attrs: { for: "invoice_postcode" } }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("booking.inputs.invoice.postcode.label")) +
                  ":\n            "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.invoice_postcode,
                  expression: "formData.invoice_postcode",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "invoice_postcode",
                id: "invoice_postcode",
                maxlength: "20",
                placeholder: _vm.$t(
                  "booking.inputs.invoice.postcode.placeholder"
                ),
                required: "",
              },
              domProps: { value: _vm.formData.invoice_postcode },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.formData,
                    "invoice_postcode",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }